import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { delay, map, catchError } from 'rxjs/operators';

import { MessageService } from '@app/core/services';

@Injectable({
	providedIn: 'root',
})
export class ErrorCatchService {
	constructor(
		public messageService: MessageService,
		public router: Router,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}

	// Catch Err function
	isCatchErrCode(x, apiName) {
		console.log(`%c API ${apiName} Error`, 'color:#24b5aa;', x);
		// console.log('x:', x);
		if (x.status === 401) {
			this.messageService.add({
				severity: 'error',
				summary: `登入已過期`,
				detail: '請重新登入',
				icon: 'bounce animated',
				life: 5000,
			});
		} else {
			// console.log(`%c API ${apiName} Error`, 'color:#24b5aa;', x);
			this.messageService.add({
				severity: 'error',
				summary: `API ${apiName} Error, status: ${x.status} `,
				detail: '請聯繫管理員',
				icon: 'bounce animated',
				life: 5000,
			});
		}
	}

	// 建立 Error 抓錯
	getError(res, apiName) {
		if (res.code !== '000') {
			console.log(`%c API ${apiName} code不等於 000`, 'color:#24b5aa;', res);
			this.messageService.add({
				severity: 'error',
				summary: '操作失敗',
				detail: `${apiName} 操作失敗，請聯絡相關人員協助排除錯誤`,
				life: 3000,
			});
			return res;
		} else {
			// 更新 token (SSR/prerender 環境沒有 localStorage，跳過)
			if (!isPlatformBrowser(this.platformId)) return res;
			let userInfo: any = localStorage.getItem('user');
			userInfo = JSON.parse(userInfo);
			if (userInfo?.currentUser?.Token && res.Token) {
				userInfo.currentUser.Token = res.Token;
				localStorage.setItem('user', JSON.stringify(userInfo));
			}
			return res;
		}
	}

	// - 呼叫靜態資料時的 err handler
	handler = (error: any) => {
		let errMsg = error.message
			? error.message
			: error.status
			? `${error.status} - ${error.statusText}`
			: 'Server error';
		console.error(errMsg);

		return new Observable<string>((observer) => {
			observer.error(errMsg);
			this.router.navigate([`/page-not-found`], { replaceUrl: true });
		});
	};
}
